var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "ex-widget" }, on: { enter: _vm.enter } },
    [
      _vm.show
        ? _c(
            "ex-mask",
            {
              on: {
                click: function($event) {
                  _vm.dismiss($event)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "actionsheet" },
                [
                  _vm.title || _vm.message
                    ? _c("header", { staticClass: "header" }, [
                        _vm.title
                          ? _c("h4", [_vm._v(_vm._s(_vm.title))])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.message))])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.list, function(group, idx) {
                    return _c(
                      "div",
                      { key: idx, staticClass: "menus" },
                      _vm._l(group, function(item, idx) {
                        return _c(
                          "div",
                          {
                            key: idx,
                            staticClass: "item",
                            class: [item.class],
                            on: {
                              click: function($event) {
                                item.click($event)
                              }
                            }
                          },
                          [_vm._v(_vm._s(item.text))]
                        )
                      })
                    )
                  })
                ],
                2
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }